(function (root, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (!root || !root.document) return;

  root.FuncinatingProductDescriptionImages = api;

  const run = (scope) => api.enhanceProductDescriptionImages(scope);

  if (root.document.readyState === 'loading') {
    root.document.addEventListener('DOMContentLoaded', () => run(root.document), { once: true });
  } else {
    run(root.document);
  }

  root.document.addEventListener('shopify:section:load', (event) => run(event.target));
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  const widths = [360, 540, 720, 960, 1320];
  const sizes = '(max-width: 1023px) calc(100vw - 32px), 660px';
  const unsupportedExtension = /\.(?:gif|svg)$/i;

  function parseShopifyImageUrl(source) {
    if (!source || typeof source !== 'string') return null;

    let url;
    try {
      url = new URL(source);
    } catch {
      return null;
    }

    const hostname = url.hostname.toLowerCase();
    const pathname = url.pathname.toLowerCase();
    const isShopifyHost =
      hostname === 'cdn.shopify.com' ||
      hostname.endsWith('.myshopify.com') ||
      hostname.endsWith('.shopifycdn.com');
    const isShopifyProxyPath = pathname.startsWith('/cdn/shop/');

    if ((!isShopifyHost && !isShopifyProxyPath) || unsupportedExtension.test(pathname)) {
      return null;
    }

    return url;
  }

  function withWidth(sourceUrl, width) {
    const url = new URL(sourceUrl.toString());
    url.searchParams.set('width', String(width));
    return url.toString();
  }

  function buildResponsiveImageAttributes(source) {
    const sourceUrl = parseShopifyImageUrl(source);
    if (!sourceUrl) return null;

    return {
      src: withWidth(sourceUrl, widths[widths.length - 1]),
      srcset: widths.map((width) => `${withWidth(sourceUrl, width)} ${width}w`).join(', '),
      sizes,
      loading: 'lazy',
      decoding: 'async',
      fetchpriority: 'low',
    };
  }

  function enhanceProductDescriptionImages(scope) {
    if (!scope || typeof scope.querySelectorAll !== 'function') return 0;

    const images = scope.querySelectorAll('.funcinating-product__details .funcinating-product__rte img');
    let enhanced = 0;

    images.forEach((image) => {
      const source = image.currentSrc || image.src || image.getAttribute('src');
      const attributes = buildResponsiveImageAttributes(source);
      if (!attributes) return;

      image.setAttribute('loading', attributes.loading);
      image.setAttribute('decoding', attributes.decoding);
      image.setAttribute('fetchpriority', attributes.fetchpriority);
      image.setAttribute('sizes', attributes.sizes);
      image.setAttribute('srcset', attributes.srcset);
      image.setAttribute('src', attributes.src);
      enhanced += 1;
    });

    return enhanced;
  }

  return {
    buildResponsiveImageAttributes,
    enhanceProductDescriptionImages,
  };
});
